var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":"http://kibana-proxy.eepos.local/goto/d1971f3fbe00fe8db398b9f757d53344","height":"700","width":"100%","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }